import { atom } from 'jotai';
import {
  endpointFundDocumentsGET,
  FundDocument,
} from '~/api/def/endpoints/fundEndpoint';
import { updateDocumentsActionAtom } from '~/atoms/document/documentsCacheAtoms';

export const documentTableRows = atom<FundDocument[]>([]);

export const documentTableLoading = atom<boolean>(false);

export const fundIdAtom = atom<string | null>(null);

export const portfolioIdAtom = atom<string | null>(null);

export const showLoaderOnPageLoad = atom(null, (get, set) => {
  set(documentTableLoading, true);
});
export const loadDocumentTable = atom(null, async (get, set, id: string) => {
  let fundId = get(fundIdAtom);
  const portfolioCompanyId = get(portfolioIdAtom);
  if (!fundId) {
    return;
  }

  const documentsResponse = await endpointFundDocumentsGET(
    id,
    portfolioCompanyId ?? undefined,
  );

  fundId = get(fundIdAtom);
  if (!fundId || fundId !== id) return;
  // let hasProcessingDocuments = false;
  if (documentsResponse?.success === 1 && 'data' in documentsResponse) {
    set(updateDocumentsActionAtom, documentsResponse.data);
    const rows = documentsResponse.data.map((doc) => {
      return {
        ...doc,
        admissionDate: doc.admissionDate ? new Date(doc.admissionDate) : null,
        createdAt: doc.createdAt ? new Date(doc.createdAt) : null,
      };
    });
    set(documentTableRows, rows);
    set(documentTableLoading, false);
  } else {
    set(documentTableRows, []);
    set(documentTableLoading, false);
  }
});
